
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'productStock/save',
        method: 'post',
        data
    })
}


export function getPageList(data) {
    return request({
        url: 'productStock/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'productStock/delete',
        method: 'post',
        data
    })
}

export function getShopStocks(data) {
    return request({
        url: 'productStock/getShopStocks',
        method: 'post',
        data
    })
}